import { queryApi } from '../../../api'
import { ENDPOINT } from '../../../constants'
import { IArkiveringStatusVars } from '../types'

export const arkiveringStatusApi = {
  getArkiveringStatus: async ({
    noarksakAar,
    noarksakSekvensnummer,
    hoveddokumentId,
  }: IArkiveringStatusVars) =>
    await queryApi.get<any>(
      `${ENDPOINT.ARKIV}/arkiv/bilder/saksnummer/${noarksakAar}/${noarksakSekvensnummer}/hoveddokumentId/${hoveddokumentId}/arkivert`
    ),
}
